import { useEffect, useRef } from "react";
import InfoIcon from "../../../../../images/info-icon.png";
import {
  selectState, setAdditionalInfoPopover, setNewAccountReceivablePopover,
} from "../accountReceivable.slice";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import Popover from "components/Popover/Popover";
import { NewAccountReceivablePopover } from "./NewAccountReceivablePopover";
import { ReceivablesAdditionalInfoPopover } from "./ReceivablesAdditionalInfoPopover";
import ToolboxButton, { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { IProjectOption } from "Dashboard/domain/IProjectOption";


interface IProps {
  projects: IProjectOption[];
};

export const AccountReceivableHeader = ({ projects }: IProps) => {
  const dispatch = useAppDispatch();
  const { newAccountReceivablePopover, additionalInfoPopover } = useSelector(selectState);
  const additionalInfoIconRef = useRef<HTMLDivElement>(null);
  const { user } = useSelector(selectStateAuth);

  useEffect(() => {
    if (additionalInfoIconRef !== undefined && additionalInfoIconRef !== null) {
      const iconRect = additionalInfoIconRef.current?.getBoundingClientRect();
      if (iconRect !== undefined) {
        const popoverPosition = { isOpen: additionalInfoPopover.isOpen, top: iconRect.top + 10, left: iconRect.left + 10 };
        dispatch(setAdditionalInfoPopover(popoverPosition));
      }
    }
  }, [dispatch, additionalInfoIconRef, additionalInfoPopover.isOpen]);

  return (
    <div className="header">
      <span className="text">Mi potražujemo</span>
      <span className="icon" ref={additionalInfoIconRef}>
        <img src={InfoIcon} alt=""
          onClick={(e) => dispatch(setAdditionalInfoPopover({ isOpen: true }))}
        />
      </span>
      <span className="rightButtons">
        <ToolboxButton
          icon={ToolboxButtonIcon.ArrowCircleDown}
          onClick={hasWriteAccessTo(user, PARTNER_MODULE_NAME) ? (e) => dispatch(setNewAccountReceivablePopover({ isOpen: true, top: e.clientY + 5, left: e.clientX })) : undefined}
          tooltip="Nova faktura"
        />
      </span>
      <Popover
        isOpen={newAccountReceivablePopover.isOpen}
        onClose={() => { dispatch(setNewAccountReceivablePopover({ isOpen: false })) }}
        direction="right"
        title="Mi potražujemo - nova faktura"
        arrowStyle={{ top: '40%' }}
        position={{ top: newAccountReceivablePopover.top, left: newAccountReceivablePopover.left, offsetLeft: 30, offsetTop: -125 }}
      >
        <NewAccountReceivablePopover projects={projects} />
      </Popover>
      <Popover
        isOpen={additionalInfoPopover.isOpen}
        onClose={() => { dispatch(setAdditionalInfoPopover({ isOpen: false })) }}
        direction="right"
        title="Veleprodaja"
        arrowStyle={{ top: '40%' }}
        position={{ top: additionalInfoPopover.top, left: additionalInfoPopover.left, offsetLeft: 20, offsetTop: -190 }}
      >
        <ReceivablesAdditionalInfoPopover />
      </Popover>
    </div>
  );
};
